module.exports = __webpack_public_path__ + "img/zip.1d1a4e42.svg";